/**
 * Common utility functions shared across the theme
 */

/**
 * Debounce function to limit how often a function can be called
 * @param {Function} fn - The function to debounce
 * @param {number} wait - Time in milliseconds to wait between calls
 * @returns {Function} - Debounced function
 */
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

/**
 * Fetch configuration for Ajax requests
 * @param {string} type - Response type (defaults to 'json')
 * @returns {Object} - Fetch configuration object
 */
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
} 